/**
 * Load the Main Page (index.html) libraries.
 */
import './config.js';
import './nav-links/nav-links-loader.js';
import './search/searchAutocomplete.js';
import './core/webhelp.js';
import './search/search-init.js';
import './context-help/context-help.js';
import './template/template-module-loader.js';
